import script from "./pairingBegin.vue?vue&type=script&setup=true&lang=js"
export * from "./pairingBegin.vue?vue&type=script&setup=true&lang=js"

import "./pairingBegin.vue?vue&type=style&index=0&id=40841fe9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40841fe9"]])

export default __exports__